<router-outlet></router-outlet>

@defer {
    <app-confirm-modal />
    <ng-container *ngIf="isAuthenticated">
    </ng-container>
}